import { jsx as _jsx } from "react/jsx-runtime";
import UIComponent from './uiComponent';
export default class UIAnchor extends UIComponent {
    constructor(s) {
        super(s);
    }
    getComponent() {
        const children = [];
        for (const c of this.children) {
            const component = c.getComponent();
            children.push(component);
        }
        return _jsx("div", { children: children });
    }
}
//# sourceMappingURL=uiAnchor.js.map